import React, {Component} from 'react'
import {defineMessages, injectIntl} from 'react-intl'

const messages = defineMessages({
    'first_short': {
        id: 'invoice.recurring.day_of_month.first_short',
        defaultMessage: 'st',
    },
    'second_short': {
        id: 'invoice.recurring.day_of_month.second_short',
        defaultMessage: 'nd',
    },
    'third_short': {
        id: 'invoice.recurring.day_of_month.third_short',
        defaultMessage: 'rd',
    },
    'something_first_short': {
        id: 'invoice.recurring.day_of_month.something_first_short',
        defaultMessage: 'st',
    },
    'something_second_short': {
        id: 'invoice.recurring.day_of_month.something_second_short',
        defaultMessage: 'nd',
    },
    'something_third_short': {
        id: 'invoice.recurring.day_of_month.something_third_short',
        defaultMessage: 'rd',
    },
    'something_else_short': {
        id: 'invoice.recurring.day_of_month.something_else_short',
        defaultMessage: 'th',
    },
    'last': {
        id: 'invoice.recurring.day_of_month.last',
        defaultMessage: 'Last day',
    },

})


class DayOfMonthLabel extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            dayOfMonth: this.props.dayOfMonth || 0,
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            dayOfMonth: nextProps.dayOfMonth || 0,
        })
    }

    render() {
        switch (this.state.dayOfMonth) {
            case 1:
                return '1' + this.props.intl.formatMessage(messages['first_short'])
            case 2:
                return '2' + this.props.intl.formatMessage(messages['second_short'])
            case 3:
                return '3' + this.props.intl.formatMessage(messages['third_short'])
            case 31:
                return this.props.intl.formatMessage(messages['last'])
            default:
                const lastDigit = this.state.dayOfMonth.toString().split('').pop()
                const dayOfMonth = this.state.dayOfMonth.toString()
                switch (lastDigit) {
                    case '1':
                        return dayOfMonth + this.props.intl.formatMessage(messages['something_first_short'])
                    case '2':
                        return dayOfMonth + this.props.intl.formatMessage(messages['something_second_short'])
                    case '3':
                        return dayOfMonth + this.props.intl.formatMessage(messages['something_third_short'])
                    default:
                        return dayOfMonth + this.props.intl.formatMessage(messages['something_else_short'])
                }
        }
        return ''
    }

}

export default injectIntl(DayOfMonthLabel)





// WEBPACK FOOTER //
// ./src/invoice/recurring/dayofmonthlabel.component.jsx